import React from 'react';
import GenerateHeading from '../dataInfoTable/generateHeading';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import {
  getRegionByStateName,
  getRegionByGlobalRegion,
  getEthnicityCodeByText,
  getOriginByCode,
  getIncomeByCode_EU,
  getIncomeByCode_UK,
  getIncomeCodeByText,
} from '../../../helperFunctions';

const DataInfoTableSm = ({ data, personaName, type, isBuyerComparison, sampleLabel }) => {
  const UsStateData = data.find(e => e.criteria === 'State');
  const personaRegion = getRegionByStateName(UsStateData.personaInfo) || '-';
  const isUKData = data.find(e => e.criteria === 'Country').batchInfo?.includes('United Kingdom');

  let consumerRegion = getRegionByStateName(UsStateData.batchInfo) || '-';
  let consumerEthnicityOrigin = data.find(e => e.criteria === 'Ethnicity/Origin').batchInfo || '-';
  let consumerIncome = data.find(e => e.criteria === 'Income').batchInfo || '-';
  if (consumerRegion === '-' && !isBuyerComparison) {
    // US data
    const batchRegion = data.find(e => e.criteria === 'Region');
    consumerRegion = getRegionByGlobalRegion(batchRegion.batchInfo) || '-';

    const batchOrigin = data.find(e => e.criteria === 'Ethnicity/Origin');
    let originCode = getEthnicityCodeByText(batchOrigin.batchInfo);
    consumerEthnicityOrigin = getOriginByCode(originCode) || '-';

    const batchIncome = data.find(e => e.criteria === 'Income');
    let incomeCode = getIncomeCodeByText(batchIncome.batchInfo);
    consumerIncome = isUKData ? getIncomeByCode_UK(incomeCode) : getIncomeByCode_EU(incomeCode);
  }

  return (
    <Table sx={{ width: '100%' }} aria-label="simple table">
      <TableHead>
        <TableRow>
          <TableCell>
            <div></div>
          </TableCell>
          <TableCell>
            <GenerateHeading isPersona={true} personaName={personaName} type={type} />
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((row, index) => {
          const isRegion = row.criteria === 'Region';
          return (
            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row" style={{ padding: '9px' }}>
                {row.criteria}
              </TableCell>
              <TableCell align="left" style={{ padding: '9px' }}>
                {isRegion ? personaRegion : row.personaInfo}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
      <div style={{ paddingBlock: '20px' }}></div>
      <TableHead>
        <TableRow>
          <TableCell>
            <div></div>
          </TableCell>
          <TableCell>
            <GenerateHeading isPersona={false} sampleLabel={sampleLabel} />
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((row, index) => {
          // Currently we don't support City and ZIP (Even though we have the fields in most_occurring)
          const isCity = row.criteria === 'City';
          const isZip = row.criteria === 'ZIP';
          if (isCity || isZip) return null;

          const isRegion = row.criteria === 'Region';
          const isEthnicityOrigin = row.criteria === 'Ethnicity/Origin';
          const isIncome = row.criteria === 'Income';
          return (
            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row" style={{ padding: '9px' }}>
                {row.criteria}
              </TableCell>
              <TableCell align="left" style={{ padding: '9px' }}>
                {isRegion
                  ? consumerRegion
                  : isEthnicityOrigin
                  ? consumerEthnicityOrigin
                  : isIncome
                  ? consumerIncome
                  : row.batchInfo}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default DataInfoTableSm;
